<main class="grid min-h-full place-items-center bg-white px-6 py-12 sm:py-16 lg:px-8">
  <div class="text-center">
    <p class="text-base font-semibold joii-text-primary">Unauthorised</p>
    <h1 class="mt-4 text-3xl font-bold tracking-tight text-gray-900 sm:text-5xl">Access Denied</h1>
    <p class="mt-6 text-base leading-7 text-gray-600">
      You do not have permission to perform this action, please logout and try again.
    </p>
    <div class="mt-10 flex items-center justify-center gap-x-6">
      <button (click)="logout()" class="joii-btn-primary">Logout</button>
    </div>
  </div>
</main>
